import * as React from "react";
import Slider from "react-slick";

import { PresentProductColorInfo, ResponseProductDinkus } from "../model";

import { ProductImageSlide } from "./product-image-slide";

interface ProductTileProps {
  url?: string;

  handleAction?: React.MouseEventHandler<HTMLAnchorElement>;

  images: any[];
  heading?: string;

  priceLabel?: string;
  priceAfter?: string;
  priceBefore: string;

  rewardsPrice?: string;

  colors: PresentProductColorInfo[] | never[];
  colorSlidesContainerWidth: number;
  colorSlidesToShow: number;
  showArrowsOnColors?: boolean;
  selectedColor?: string;

  handleActionColorSwatch: (color: PresentProductColorInfo) => void;

  promoNotes?: string | null;
  stockStatus?: string | null;

  disableImageSlider?: boolean;

  dinkus?: ResponseProductDinkus;
}

export const ProductTile: React.FunctionComponent<ProductTileProps> = (
  props
) => {
  const [isHovering, setIsHovering] = React.useState(false);

  const colorSliderRef = React.useRef<Slider>(null);
  const [hasInitiallyPutColorInView, setHasInitiallyPutColorInView] =
    React.useState(false);

  React.useEffect(() => {
    if (props.colors.length < 2) {
      setHasInitiallyPutColorInView(true);
    } else if (colorSliderRef.current) {
      if (!hasInitiallyPutColorInView) {
        if (props.selectedColor) {
          const thisColorIndex = props.colors.findIndex(
            ({ key }) => key === props.selectedColor
          );
          if (thisColorIndex >= 0) {
            colorSliderRef.current.slickGoTo(thisColorIndex);
          }
        }
        setHasInitiallyPutColorInView(true);
      }
    }
  }, [
    props.colors,
    props.selectedColor,
    colorSliderRef,
    hasInitiallyPutColorInView,
  ]);

  const onMouseOverTopLinks = () => {
    setIsHovering(true);
  };
  const onMouseOutTopLinks = () => {
    setIsHovering(false);
  };
  const onMouseOverBottomLinks = () => {
    setIsHovering(true);
  };
  const onMouseOutBottomLinks = () => {
    setIsHovering(false);
  };

  return (
    <article className={`${isHovering ? "hovering" : ""}`}>
      <a
        href={props.url}
        onClick={props.handleAction}
        onMouseOver={onMouseOverTopLinks}
        onMouseOut={onMouseOutTopLinks}
      >
        <Slider
          className={`product-images ${
            !props.disableImageSlider && props.images.length > 1
              ? "has-arrows"
              : "no-arrows"
          }`}
          dots={!props.disableImageSlider && !!(props.images.length > 1)}
          infinite
          lazyLoad="ondemand"
        >
          {props.images.map((image, index) => {
            if (props.disableImageSlider && index > 0) {
              return null;
            }
            return (
              <ProductImageSlide
                key={index}
                src={image}
                alt={props.heading}
                dinkus={props.dinkus}
              />
            );
          })}
        </Slider>
        <p
          className={`title ${
            !!(props.images.length > 1) ? "showing-dots-above" : ""
          }`}
        >
          {props.heading}
        </p>
        <p className="main-price">
          {props.priceLabel && (
            <span className="label">{props.priceLabel}&nbsp;</span>
          )}
          {props.priceAfter ? (
            <React.Fragment>
              <span className="price-after">&#36;{props.priceAfter}&nbsp;</span>
              <span className="price-before">&#36;{props.priceBefore}</span>
            </React.Fragment>
          ) : (
            <span className="regular-price">&#36;{props.priceBefore}</span>
          )}
        </p>
        {props.rewardsPrice && (
          <p className="rewards-price">Members: &#36;{props.rewardsPrice}</p>
        )}
      </a>
      {props.colors.length > 1 ? (
        <div
          style={{
            width: props.colorSlidesContainerWidth as number,
          }}
          className={`product-colors-container ${
            props.showArrowsOnColors ? "with-arrows" : ""
          }`}
        >
          <Slider
            ref={colorSliderRef}
            className="product-colors"
            swipeToSlide={true}
            slidesToShow={props.colorSlidesToShow as number}
            infinite={false}
          >
            {props.colors.map((color) => {
              return (
                <div
                  className={`bbnt-product-color-slide ${
                    color.key === props.selectedColor
                      ? "bbnt-product-color-slide-selected"
                      : ""
                  }`}
                >
                  <div className="color-swatch-container">
                    {color.isImage ? (
                      <img
                        src={color.value}
                        onClick={() => props.handleActionColorSwatch(color)}
                        width="32px"
                        height="32px"
                      />
                    ) : (
                      <div
                        style={{
                          backgroundColor: color.value,
                        }}
                        onClick={() => props.handleActionColorSwatch(color)}
                      />
                    )}
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
      ) : null}
      <a
        href={props.url}
        onClick={props.handleAction}
        onMouseOver={onMouseOverBottomLinks}
        onMouseOut={onMouseOutBottomLinks}
      >
        {props.promoNotes && <p className="promo">{props.promoNotes}</p>}
        {props.stockStatus && (
          <p className="stock-status">{props.stockStatus}</p>
        )}
      </a>
    </article>
  );
};
